<template>
    <div>
        <b-form-group :label="field.label" :label-for="`id_${field._id}`" :class="{
            'required-field': field.isRequired,
        }">
            <b-form-input v-model="model" v-validate="{
                required: field.isRequired,
                email: !!field.isEmail,
                numeric:
                    this.$store.state.registration.form.identityInfo.type ==
                        'passport'
                        ? false
                        : !!field.isNumeric,
                alpha_num:
                    this.$store.state.registration.form.identityInfo.type ==
                        'passport'
                        ? !!field.isAlphaNum
                        : field.isAlphaNum
                            ? !!field.isAlphaNum
                            : !!field.isAlphaNum,
                alpha_spaces: !!field.isAlpha,
                min:
                    this.$store.state.registration.form.identityInfo.type ==
                        'passport'
                        ? 1
                        : field.minLength
                            ? field.minLength
                            : 1,
                max:
                    field.maxLength != null
                        ? field.maxLength
                        : this.$store.state.registration.form.identityInfo.type == 'passport'
                            ? 100
                            : this.$store.state.registration.form.identityInfo.type == 'id'
                                ? 50
                                : 100
            }" type="text" autocomplete="no" :placeholder="field.placeholder" :disabled="loading"
                :data-vv-name="field.label" :class="{
                    'is-invalid': errors.has(field.label),
                }"></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            value: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'form']),

        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                if (typeof newValue === 'string') {
                    newValue = newValue.replace(/\s+/g, ' ').trim()
                }
                this.value = newValue
                console.log('textfield value', newValue)
                console.log('textfield key', this.field.key)
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        // initialize if custom field

        if (!this.field.isLocked) {
            this.$store.commit('initCustomField', {
                key: `${this.field._id}`,
                value: {
                    title: this.field.label,
                    type: this.field.type,
                    value: null,
                },
            })
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
